import { name } from './constants';
export var selectIdsMapState = function (state) { return state[name]; };
export var selectIdsMap = function (state) {
    return selectIdsMapState(state).data;
};
export var selectIsIdsMapLoaded = function (state) {
    return selectIdsMapState(state).loading === 'fulfilled';
};
